var _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookAppointment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 187,
    viewBox: "0 0 195 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 138.5,
    r: 48.5,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 52.5,
    r: 13.5,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 158,
    r: 13,
    fill: "#D9D9D9",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 43H124V38C124 35.24 121.76 33 119 33C116.24 33 114 35.24 114 38V43H74V38C74 35.24 71.76 33 69 33C66.24 33 64 35.24 64 38V43H59C45.215 43 34 54.215 34 68V128C34 141.785 45.215 153 59 153H129C142.785 153 154 141.785 154 128V68C154 54.215 142.785 43 129 43ZM59 53H129C137.27 53 144 59.73 144 68V73H44V68C44 59.73 50.73 53 59 53ZM129 143H59C50.73 143 44 136.27 44 128V83H144V128C144 136.27 137.27 143 129 143ZM114 113C114 115.76 111.76 118 109 118H99V128C99 130.76 96.76 133 94 133C91.24 133 89 130.76 89 128V118H79C76.24 118 74 115.76 74 113C74 110.24 76.24 108 79 108H89V98C89 95.24 91.24 93 94 93C96.76 93 99 95.24 99 98V108H109C111.76 108 114 110.24 114 113Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookAppointment);
export default __webpack_public_path__ + "static/media/book_appointment.ac5e7314f6ac200a462589643c8bb945.svg";
export { ForwardRef as ReactComponent };